import clsx from "clsx";
import { Icon, KeyValueList, NoData } from "../../../../components";
import { Link } from "../../../../components/link";
import ExpandableValue from "./ExpandableValue";
import { SampleIOCDataProps } from "../../@types/ioc";
import styles from "./ioc.module.scss";

interface SampleAttributionListProps extends SampleIOCDataProps {
  hideActors?: boolean;
}

const SampleAttributionList = ({
  sampleIOCData,
  hideActors = false
}: SampleAttributionListProps) => {
  const victims = sampleIOCData?.related_victims
    ?.map(victim => victim.name)
    .join("; ");

  const vulnerabilities = sampleIOCData?.related_vulnerabilities
    ?.map(vulnerability => vulnerability.cve_id)
    .join(", ");

  const campaigns = sampleIOCData?.related_campaigns
    ?.map(campaign => campaign.name)
    .join(", ");

  return (
    <KeyValueList className={styles.ioc_key_value_entry}>
      <>
        {!hideActors && (
          <KeyValueList.Item
            label="Actor Name: "
            value={
              sampleIOCData?.related_actors?.length ? (
                sampleIOCData.related_actors.map(actor => {
                  const countryCode = actor.state_attribution?.country;
                  return (
                    <span
                      key={actor.name}
                      className={clsx("inline-flex", styles.actor_name_item)}
                    >
                      {countryCode && (
                        <Icon
                          name={countryCode.toLowerCase()}
                          flag
                          className="me-5"
                        />
                      )}
                      {actor.name}
                    </span>
                  );
                })
              ) : (
                <NoData />
              )
            }
            className="overflow-ellipsis"
          />
        )}
      </>
      <KeyValueList.Item
        label="Campaigns: "
        value={<ExpandableValue value={campaigns} fallback={<NoData />} />}
      />
      <KeyValueList.Item
        label="Victims: "
        value={<ExpandableValue value={victims} fallback={<NoData />} />}
      />
      <KeyValueList.Item
        label="Vulnerabilities: "
        value={
          <ExpandableValue value={vulnerabilities} fallback={<NoData />} />
        }
      />
      <KeyValueList.Item
        label="Sources: "
        value={
          sampleIOCData?.sources?.map(source => (
            <div key={`sample_attr_${source}`} className="overflow-ellipsis">
              <Link href={source} target="_blank" className="overflow-ellipsis">
                {source}
              </Link>
            </div>
          )) || <NoData />
        }
      />
    </KeyValueList>
  );
};

export default SampleAttributionList;
